import { Sound } from './sounds.model';

export class Beat {
  constructor(public name: string, public beatSequence: Sound[] []) {

  }
}



// WEBPACK FOOTER //
// /Users/BREA/Desktop/drum-machine/src/app/models/beat.model.ts